import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { StockPriceData } from "./stockprice.type";

type GetStockpriceProps = {
  requestInstance: ChameleonRequest;
  productIds: number | number[];
  store: string;
  keyStoreDataversion: string;
  country: string;
  lang: string;
  shop: string;
  currency?: string;
  sizeSchema?: string;
};

export const getStockPriceData = async (props: GetStockpriceProps) => {
  const { requestInstance, productIds, ...searchParams } = props;

  const url = getApiUrl({
    path: `/product/catalogue/v4/stockprice/`,
    searchParams: {
      ...searchParams,
      productIds: Array.isArray(productIds) ? productIds : [productIds],
    },
  });

  try {
    const response = await requestInstance.get<StockPriceData[]>(
      url,
      undefined,
      {
        requestType: "STOCK_PRICE_API",
      },
    );

    return response.data || null;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
